// Single source of truth for predmet phases. Labels and colours were
// previously duplicated across Predmeti, PredmetList and PredmetView.
export const REOPENED_ID = 8;
export const CLOSED_ID = 10;

export const STATUSES = [
  { id: 0, label: "Otvoreno", dot: "#5b8def", tint: "#eef4ff", border: "#cfe0fb", text: "#1e4c9a" },
  { id: 1, label: "Dokumentacija", dot: "#4fa3c7", tint: "#eaf6fb", border: "#c5e3ef", text: "#1f6580" },
  { id: 2, label: "Zahtjev", dot: "#46b08c", tint: "#eaf6f1", border: "#c3e5d7", text: "#1d6b52" },
  { id: 3, label: "Čeka se odgovor klijenta", dot: "#c9a227", tint: "#faf3dd", border: "#ecdcae", text: "#8a6d0b" },
  { id: 4, label: "Prigovor", dot: "#d97742", tint: "#fdf0e7", border: "#f4d6c1", text: "#9a4f1c" },
  { id: 5, label: "Sporazum", dot: "#7c6fd0", tint: "#f0eefa", border: "#d8d2f0", text: "#4f409e" },
  { id: 6, label: "Čeka se račun klijenta", dot: "#b5729b", tint: "#f9eef5", border: "#ead0e0", text: "#86436d" },
  { id: 7, label: "Tužba", dot: "#c25b6a", tint: "#fbeef0", border: "#f2ccd3", text: "#9b3345" },
  { id: 10, label: "Zatvoreno", dot: "#94a3b8", tint: "#f1f5f9", border: "#dde5ec", text: "#55647a" },
  // Written to a case's history when an admin reopens a closed case. It is
  // never a phase you can sit in, so it is kept out of pickers and filters.
  {
    id: REOPENED_ID,
    label: "Ponovo otvoreno",
    dot: "#2f6fed",
    tint: "#eef4ff",
    border: "#b8ccf5",
    text: "#1d4ed8",
    historyOnly: true,
  },
];

// Phases a case can actually be moved to.
export function selectablePhases() {
  return STATUSES.filter((s) => !s.historyOnly);
}

const UNKNOWN = { id: -1, label: "N/A", dot: "#cbd5e1", tint: "#f1f5f9", border: "#e2e8f0", text: "#64748b" };

export function getStatus(id) {
  return STATUSES.find((s) => s.id === id) || UNKNOWN;
}

export function getStatusLabel(id) {
  return getStatus(id).label;
}

// Options for the phase filter; -1 means every open phase.
export function statusFilterOptions() {
  return [{ value: -1, label: "Faza — sve" }].concat(
    selectablePhases()
      .filter((s) => s.id !== CLOSED_ID)
      .map((s) => ({ value: s.id, label: s.label }))
  );
}

// Every phase including Zatvoreno, plus an "all" entry — for the admin view,
// which searches across open and closed cases alike.
export const ALL_PHASES = -2;

export function adminFilterOptions() {
  return [{ value: ALL_PHASES, label: "Faza — sve (uklj. zatvorene)" }].concat(
    selectablePhases().map((s) => ({ value: s.id, label: s.label }))
  );
}

// Phases are counted as "stalled" once a case has sat in one this long.
export const STALE_DAYS = 30;
export const WARN_DAYS = 14;
